module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/continue.f1d11d62979bf557d00d3ddf7d450b3a.svg";